var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppBaseModal',_vm._g({attrs:{"title":_vm.title,"modal-width":455}},_vm.$listeners),[_c('ContactForm',{attrs:{"external-subject":_vm.externalSubject,"target-api-endpoint-name":_vm.targetApiEndpointName,"modal-mode":""},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }